import { Outlet } from 'react-router-dom';
import ProjectHeader from './ProjectHeader';
import PageBackBar from './PageBackBar';
import BrowserNotifyListener from './BrowserNotifyListener';

/* ctAS app shell — full-height flex column. Only the body scrolls;
   the header and back bar are fixed bands. Hub-and-spoke: no sidebar. */
export default function AppLayout() {
  return (
    <div className="scpa-shell">
      <BrowserNotifyListener />
      <ProjectHeader homePath="/" profilePath="/profile" ticketsPath="/tickets" newTicketPath="/tickets/new" showWhatsNew />
      <PageBackBar />
      <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
        <div style={{ position: 'absolute', inset: 0, overflowY: 'auto' }}>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%', padding: '1rem clamp(0.75rem, 3vw, 1.5rem)' }}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
